import { SubmissionError } from 'redux-form';
import ActionTypes from '../constants/ActionTypes';
import { createAction } from 'redux-actions';
import { redeemExtraVoucher, removeExtraVoucher } from '../api/voucher';
import { setCookieToken, getTokenFromCookie } from '../utils/token';
import { setInstallToken } from './install';
import Convert from '../utils/convert';

export const submitExtraInstallForm = form => {
  return async (dispatch, getState) => {
    const state = getState();
    const { list } = state.extra;

    const formVoucher = form.extra_install_voucher || '';
    const voucher = Convert.voucher(formVoucher);

    const formPurchaseDate = form.pdate || '';
    const purchaseDate = Convert.date(formPurchaseDate);
    // validate code
    if (list && list[0] && list[0].voucher === formVoucher) {
      throw new SubmissionError({
        extra_install_voucher_error:
          'The voucher has already been added, please add another one. If you’re stuck, call 1300 043 520',
        extra_install_voucher: true,
        pdate: true
      });
    } else {
      if (voucher.length !== 14) {
        throw new SubmissionError({
          install_voucher_error: 'Please enter 14 digits voucher code.'
        });
      } else if (purchaseDate.length !== 8) {
        throw new SubmissionError({
          install_voucher_error: 'Please choose a purchase date.'
        });
      }
      let voucherRedeem = voucher;
      if (voucher.length === 14) {
        voucherRedeem = voucher + purchaseDate;
      }
      try {
        const { data } = await redeemExtraVoucher(voucherRedeem, getTokenFromCookie());
        if (data.status === 0 && data.token) {
          const newToken = data.token;
          setCookieToken(newToken);
          dispatch(setInstallToken(newToken));
          const extraInsallData = {
            voucher: formVoucher,
            date: formPurchaseDate,
            categories: data.categories,
            canRemove: true
          };
          dispatch(
            createAction(ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_SUCCESS)(extraInsallData)
          );
          dispatch(createAction(ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_DONE)());
        }
      } catch (e) {
        throw new SubmissionError({
          extra_install_voucher_error:
            'There’s an issue with this install code and date combination, please check it again. If you’re stuck, call 1300 043 520',
          extra_install_voucher: true,
          pdate: true
        });
      }
    }
  };
};

export function addExtraInstall() {
  return {
    type: ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_REQUEST
  };
}

export const removeExtraInstall = (voucher, date) => {
  return async dispatch => {
    const code = Convert.voucher(voucher) + Convert.date(date);
    if (voucher) {
      try {
        const { data } = await removeExtraVoucher(code, getTokenFromCookie());
        if (data.status === 0 && data.token) {
          const newToken = data.token;
          setCookieToken(newToken);
          dispatch(setInstallToken(newToken));
          dispatch(createAction(ActionTypes.EXTRA_INSTALL_VOUCHER_REMOVE_SUCCESS)(voucher));
        }
      } catch (e) {
        alert(`Failed to remove voucher '${voucher}'`);
      }
    }
  };
};
